import {NgModule} from '@angular/core';
import {AmModule} from "./am/am.module";
import {AuModule} from "./au/au.module";
import {CbModule} from "./cb/cb.module";
import {DmModule} from "./dm/dm.module";
import {NsModule} from "./ns/ns.module";
import {TeModule} from "./te/te.module";
import {TmModule} from "./tm/tm.module";
import {UfModule} from "./uf/uf.module";
import {UmModule} from "./um/um.module";
import {WfModule} from "./wf/wf.module";
import {AdModule} from "./ad/ad.module";
import {CdModule} from "./cd/cd.module";
import {CoModule} from "./co/co.module";
import {DqModule} from "./dq/dq.module";
import {FeatureCoreRoutingModule} from "./feature-core.routing.module";

@NgModule({
    exports: [
        AmModule,
        AuModule,
        CbModule,
        DmModule,
        NsModule,
        TeModule,
        TmModule,
        UfModule,
        UmModule,
        WfModule,
        AdModule,
        CdModule,
        CoModule,
        DqModule,
    ],
    imports: [
        AmModule,
        AuModule,
        CbModule,
        DmModule,
        NsModule,
        TeModule,
        TmModule,
        UfModule,
        UmModule,
        WfModule,
        AdModule,
        CdModule,
        CoModule,
        DqModule,
        FeatureCoreRoutingModule
    ]
})
export class FeatureCoreModule {
}